<template>
    <div class="flex-row pagebreak-box">
        <div v-show="show" class="page-box">
            <button
                @click="goPrev"
                :class="['prev-page', currentPage == 1 ? 'disable' : '']"
            >
                上一页
            </button>
            <ul>
                <li
                    v-for="(item, index) in pageList"
                    :key="index"
                    :class="[
                        item == currentPage ? 'active' : '',
                        item == '...' ? 'ellipsis' : ''
                    ]"
                    @click="changePage(item)"
                >
                    {{ item }}
                </li>
            </ul>
            <button
                @click="goNext"
                :class="[
                    'next-page',
                    currentPage == totalPage ? 'disable' : ''
                ]"
            >
                下一页
            </button>
            <div class="total-pages">共{{ totalPage }}页</div>
            <div class="jump-page">
                到第<input
                    @keyup.enter="jump"
                    type="text"
                    v-model="num"
                    value="1"
                />页
            </div>
            <button @click="jump" class="jump-btn">确定</button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        totalPage: {
            default: 1
        },
        current: {
            default: 1
        },
        max: {
            default: 7
        }
    },
    data() {
        return {
            pageList: [],
            show: false,
            currentPage: 1,
            num: 1,
            maxPage: 7,
            sub: 3,
            add: 3
        };
    },
    created() {
        this.currentPage = this.current;
        this.maxPage = this.max;
        this.setPage();
    },
    methods: {
        setPage() {
            if (this.totalPage == 0) {
                this.show = false;
                return;
            }
            if (this.maxPage < 7) {
                this.maxPage = 7;
            }
            this.show = true;
            this.pageList = [];

            this.sub = Math.ceil((this.maxPage - 1) / 2);
            this.add = parseInt((this.maxPage - 1) / 2);

            if (this.totalPage <= this.maxPage) {
                for (var i = 1; i <= this.totalPage; i++) {
                    this.pageList.push(i);
                }
            } else if (this.currentPage - this.sub <= 1) {
                for (var i = 1; i <= this.maxPage - 2; i++) {
                    this.pageList.push(i);
                }
                this.pageList.push("...");
                this.pageList.push(this.totalPage);
            } else if (this.currentPage + this.add < this.totalPage) {
                this.pageList.push(1);
                this.pageList.push("...");
                for (
                    var i = this.currentPage - this.sub + 2;
                    i <= this.currentPage + this.add - 2;
                    i++
                ) {
                    this.pageList.push(i);
                }
                this.pageList.push("...");
                this.pageList.push(this.totalPage);
            } else if (this.totalPage - this.current > this.add) {
                this.pageList.push(1);
                this.pageList.push("...");
                for (
                    var i = this.totalPage - this.maxPage + 3;
                    i <= this.totalPage;
                    i++
                ) {
                    this.pageList.push(i);
                }
            }
        },
        changePage(index) {
            if (parseInt(index)) {
                this.currentPage = parseInt(index);
                this.setPage();
            }
        },
        goPrev() {
            if (parseInt(this.currentPage) <= 1) {
                return;
            }
            this.currentPage = parseInt(this.currentPage) - 1;
            this.setPage();
        },
        goNext() {
            if (parseInt(this.currentPage) >= this.totalPage) {
                return;
            }
            this.currentPage = parseInt(this.currentPage) + 1;
            this.setPage();
        },
        jump() {
            this.currentPage = parseInt(this.num);
            this.setPage();
        }
    },
    watch: {
        num: function(nval, oval) {
            this.num = nval.toString().replace(/[^\d]/g, "");
            if (this.num > this.totalPage) {
                this.num = this.totalPage;
            }
        },
        currentPage: function(nval, oval) {
            this.currentPage = nval;
            this.$emit("changePage", this.currentPage);
        },
        totalPage: function(nval) {
            this.setPage();
        },
        current: function(nval) {
            this.currentPage = nval;
            this.maxPage = this.max;
            this.setPage();
        }
    }
};
</script>

<style lang="scss" scoped>
.pagebreak-box {
    margin: 20px auto;
    height: 50px;
    .page-box {
        margin: 0 auto;
        height: 30px;
        line-height: 30px;
        div {
            display: inline-block;
            vertical-align: top;
        }
        ul {
            display: inline-block;
            vertical-align: top;
            li {
                display: inline-block;
                font-size: 16px;
                padding: 0 10px;
                background-color: #eee;
                border-radius: 4px;
                height: 30px;
                margin: 0 3px;
                cursor: pointer;
            }
            .active {
                background-color: #409eff;
                color: #fff;
                border: 0;
            }
            .active:hover {
                background-color: #409eff;
                color: #fff;
                border: 0;
            }
            .ellipsis {
                background-color: #fff;
                font-weight: bold;
                cursor: default;
            }
            .ellipsis:hover {
                background-color: #fff;
                font-weight: bold;
            }
            li:hover {
                background-color: #bbb;
            }
        }
        button {
            vertical-align: top;
            height: 30px;
            padding: 0 10px;
            border: 0;
            background-color: #eee;
            border-radius: 4px;
            display: inline-block;
            border: 1px solid #aaa;
            cursor: pointer;
        }
        button:hover {
            background-color: #bbb;
        }
        .disable {
            color: #999;
        }
        .disable:hover {
            background-color: #eee;
            cursor: not-allowed;
        }
        .prev-page {
            margin-right: 5px;
        }
        .next-page {
            margin-left: 5px;
        }
        .total-pages {
            margin: 0 10px;
            font-size: 15px;
        }
        .jump-page {
            input {
                height: 30px;
                width: 30px;
                border: 1px solid #aaa;
                margin: 0 5px;
                border-radius: 4px;
                text-align: center;
            }
        }
        .jump-btn {
            background-color: #eee;
            border: 1px solid #aaa;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/common/pagebreak.vue